export default "__VITE_ASSET__915f3163__"